/**
 * MAHSULOT nomi — platformaning o'zi.
 *
 * MAKTAB nomi bilan ARALASHTIRMANG. Ular ikki xil tushuncha va ikki xil joyda
 * ko'rinadi:
 *
 *   MAHSULOT (`PRODUCT_NAME`) — panel (platforma) nomi. Login sahifasining
 *   tagi, brauzer sarlavhasining ikkinchi qismi. Hamma tenantda BIR XIL.
 *   Huquqiy hujjatlar va /delete-account esa MOBIL ILOVA nomi (`APP_NAME`) va
 *   dasturchi (`DEVELOPER_*`) bilan yoziladi — Google Play ilova sahifasidagi
 *   nom bilan bir xil bo'lishi shart (pastga qarang).
 *
 *   MAKTAB (`user.tenantName`) — foydalanuvchi maktabining o'z nomi
 *   ("SATA", "AL-XORAZMIY", ...). Panel sarlavhasida, login sahifasida va
 *   hujjatlarda AYNAN SHU turadi. Har tenantda BOSHQACHA.
 *
 * Ilgari sarlavhaga mahsulot nomi qattiq yozilgan edi — ya'ni boshqa maktab
 * panelga kirsa ham o'zinikini emas, birinchi mijozning nomini ko'rardi.
 */
export const PRODUCT_NAME = 'UFLEX School';

/**
 * Brauzer sarlavhasi: maktab bor bo'lsa u birinchi, mahsulot ikkinchi.
 * Maktabsiz (platforma superadmini) — faqat mahsulot nomi.
 */
export function pageTitle(tenantName?: string | null): string {
  return tenantName ? `${tenantName} — ${PRODUCT_NAME}` : PRODUCT_NAME;
}

/**
 * MOBIL ILOVA va DASTURCHI — huquqiy hujjatlar (`legal/content.ts`) va ochiq
 * `/delete-account` sahifasi uchun. Google Play ilova sahifasidagi nom va
 * dasturchi bilan AYNAN bir xil bo'lishi kerak (do'kon talabi). Panelning o'z
 * sarlavhalari (`PRODUCT_NAME`) bunga tegmaydi.
 */
export const APP_NAME = 'My SATA';
export const DEVELOPER_NAME = 'UFLEX';
export const DEVELOPER_URL = 'https://uflex.uz';

/**
 * DOIMIY aloqa email'i — maxfiylik va akkauntni o'chirish masalalari uchun.
 * Maktabga BOG'LIQ EMAS: login'siz ochilgan sahifada ham ko'rinadi (maktabning
 * o'z support email'i — `Tenant.supportEmail` — sessiya bo'lsa qo'shimcha chiqadi).
 * Almashtirish kerak bo'lsa — FAQAT shu yerda (ilovadagi nusxa: app `src/legal/content.ts`).
 */
export const PRIVACY_CONTACT_EMAIL = 'ulugbekmirdadayev1211@gmail.com';

/** Panel domeni — huquqiy sahifalar va akkauntni o'chirish sahifasi shu yerda. */
export const PANEL_SITE = 'mataa.uz';
/** Akkauntni o'chirish sahifasining TO'LIQ manzili (Google Play'ga shu kiritiladi). */
export const DELETE_ACCOUNT_URL = `https://${PANEL_SITE}/delete-account`;
